// Melvin - Order Sessions Countdown
// Met à jour en temps réel tous les éléments [data-order-countdown]

(function () {
  function formatCountdown(targetDate) {
    const now = Date.now();
    const diff = targetDate - now;

    if (diff <= 0) return null;

    const totalSeconds = Math.floor(diff / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const parts = [];
    if (days > 0) parts.push(days + 'j');
    if (hours > 0 || days > 0) parts.push(hours + 'h');
    if (minutes > 0 || hours > 0 || days > 0) parts.push(minutes + 'm');
    parts.push(seconds + 's');

    return parts.join(' ');
  }

  function formatDateLabel(targetDate) {
    return targetDate.toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      timeZone: 'UTC',
    }) + ' à ' + targetDate.toLocaleTimeString('fr-FR', {
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'UTC',
    });
  }

  function updateAll() {
    var elements = document.querySelectorAll('[data-order-countdown]');
    elements.forEach(function (el) {
      var iso = el.getAttribute('data-order-countdown');
      if (!iso) return;

      // Forcer l'interprétation UTC : la valeur stockée est l'heure voulue en UTC
      var isoUtc = /Z$|[+-]\d{2}:\d{2}$/.test(iso) ? iso : iso + 'Z';
      var targetDate = new Date(isoUtc);
      if (isNaN(targetDate.getTime())) return;

      var countdown = formatCountdown(targetDate);
      if (!countdown) {
        el.style.display = 'none';
        return;
      }

      var isOpen = el.getAttribute('data-order-open') === 'true';
      var label = isOpen
        ? 'Fermeture des commandes personnalisées dans '
        : 'Ouverture des commandes personnalisées dans ';

      var dateLabel = formatDateLabel(targetDate);
      el.textContent = label + countdown + ' (' + dateLabel + ')';
      el.style.display = '';
    });
  }

  // Démarrer quand le DOM est prêt
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      updateAll();
      setInterval(updateAll, 1000);
    });
  } else {
    updateAll();
    setInterval(updateAll, 1000);
  }
})();
